





































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import VueVegaEmbed from '@/components/Vis/Vega/VueVegaEmbed.vue';
import { TopLevelSpec } from 'vega-lite';
import { EXPORT_DATA, FETCH_EMAIL_TIMELINE } from '@/store/action-types';
import { LOAD_STATE } from '@/store/shared';
import { IEmailsByDate, LoadState } from '@/store/types';
import BarLoader from '@/components/UI/Loader/BarLoader.vue';
import FooterLoader from '@/components/UI/Loader/FooterLoader.vue';
import HeaderLoader from '@/components/UI/Loader/HeaderLoader.vue';
import { genBarSpec } from '@/components/Vis/Vega/Specs/TimeBarSpec';
import { descending } from 'd3-array';
import { emailStatusConfigs } from '@/helpers/stats-utils';
import { timeDay } from 'd3-time';

export default Vue.extend({
  name: 'DunningTimeline',
  async created() {
    this.$store.dispatch(FETCH_EMAIL_TIMELINE);
  },
  components: {
    VueVegaEmbed,
    BarLoader,
    HeaderLoader,
    FooterLoader,
  },
  data() {
    return {
      statusConfigs: emailStatusConfigs,
    };
  },
  computed: {
    dunningEmailTimelineLoadState(): LoadState {
      return this.$store.state.dunningEmailTimelineLoadState;
    },
    dunningEmailTimeline(): IEmailsByDate[] {
      return this.$store.state.dunningEmailTimeline;
    },
    loading(): boolean {
      return this.dunningEmailTimelineLoadState !== LOAD_STATE.LOADED;
    },
    stats(): IEmailsByDate[] {
      return this.dunningEmailTimeline;
    },
    chartVegaSpec(): TopLevelSpec | null {
      if (this.stats && this.stats.length) {
        // filter out emails that got scheduled after date was past
        const filtered = this.stats
          .filter((d) => !(d.status === 'scheduled' && d.sendDate < timeDay.offset(new Date(), -1)))
          .filter((d) => d.status !== 'skipped' && d.status !== 'inactive');
        return genBarSpec({
          data: filtered,
          xField: 'sendDate',
          yField: 'count',
          colorField: 'status',
          timeUnit: 'yearmonthdate',
          xLabels: true,
          yLabels: true,
          yAxisTitle: 'Emails',
          barLabels: false,
          colorScale: {
            domain: emailStatusConfigs.map((d) => d.name),
            range: emailStatusConfigs.map((d) => d.color),
          },
          yFormat: '0.2s',
        });
      }
      return null;
    },
  },
  methods: {
    exportData() {
      const sortedData = [...this.stats].sort((a, b) => descending(a.sendDate, b.sendDate));
      this.$store.dispatch(EXPORT_DATA, {
        data: sortedData,
        name: 'recovery-timeline',
        csv: true,
      });
    },
  },
});
